import { render, staticRenderFns } from "./StanningLogDetail.vue?vue&type=template&id=12233c22&scoped=true&"
import script from "./StanningLogDetail.vue?vue&type=script&lang=js&"
export * from "./StanningLogDetail.vue?vue&type=script&lang=js&"
import style0 from "./StanningLogDetail.vue?vue&type=style&index=0&id=12233c22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12233c22",
  null
  
)

export default component.exports